import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Qual o formato do curso?',
      answer: 'Você terá acesso a diversas vídeo aulas (passo a passo) + Bônus Especiais.'
    },
    {
      question: 'Quais as formas de pagamento?',
      answer: 'Você tem as opções de pagamento via cartões de crédito, boleto, PIX ou paypal.'
    },
    {
      question: 'Ainda não recebi o curso, o que fazer?',
      answer: 'Verifique as caixas de spam/lixo/outros de seu e-mail, pois o link de acesso pode ser redirecionado para alguma dessas pastas.'
    },
    {
      question: 'Como vou receber o curso?',
      answer: 'Assim que seu pedido for aprovado, o link de acesso ao curso será enviado ao seu e-mail, onde você terá acesso à sua área de membros do curso com login e senha pessoal.'
    },
    {
      question: 'Tenho que pagar alguma mensalidade?',
      answer: 'Não, esse valor é único. Sem qualquer taxa ou mensalidade adicional.'
    },
    {
      question: 'Por quanto tempo terei acesso ao curso?',
      answer: 'Você terá acesso ao curso por 1 ano, podendo Acessar quantas vezes quiser nesse período, e caso não se sinta satisfeito com sua compra, você pode fazer o cancelamento em até 7 dias.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <div className="container">
        <h2 className="section-title">Perguntas Frequentes</h2>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button 
                className="faq-question" 
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

